// extracted by mini-css-extract-plugin
export default {"submenu":"Dropdown_submenu__7dedW","submenuItem":"Dropdown_submenuItem__F9nqj"};